var _defs, _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgKaListe(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 160 160",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".cls-1{fill:none;}.cls-2{fill:#f3f5fb;}.cls-3{opacity:0.97;}.cls-4{fill:#86b5ff;}.cls-5{fill:#003d94;}"))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Ebene_2",
    "data-name": "Ebene 2"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Maske"
  }, /*#__PURE__*/React.createElement("rect", {
    className: "cls-1",
    width: 160,
    height: 160,
    rx: 8
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M126.79,152H34.58a2.86,2.86,0,0,1-2.71-3V11a2.86,2.86,0,0,1,2.71-3h92.21a2.86,2.86,0,0,1,2.71,3V149A2.86,2.86,0,0,1,126.79,152Z"
  }), /*#__PURE__*/React.createElement("g", {
    className: "cls-3"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M118.13,57.48H73.25A2.48,2.48,0,0,1,70.77,55h0a2.48,2.48,0,0,1,2.48-2.49h44.88A2.48,2.48,0,0,1,120.61,55h0A2.48,2.48,0,0,1,118.13,57.48Z"
  })), /*#__PURE__*/React.createElement("g", {
    className: "cls-3"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M118.13,87.64H73.25a2.48,2.48,0,0,1-2.48-2.48h0a2.48,2.48,0,0,1,2.48-2.48h44.88a2.48,2.48,0,0,1,2.48,2.48h0A2.48,2.48,0,0,1,118.13,87.64Z"
  })), /*#__PURE__*/React.createElement("g", {
    className: "cls-3"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M112.73,132.89H73.25a2.48,2.48,0,0,1-2.48-2.48h0a2.48,2.48,0,0,1,2.48-2.48h39.48a2.48,2.48,0,0,1,2.48,2.48h0A2.48,2.48,0,0,1,112.73,132.89Z"
  })), /*#__PURE__*/React.createElement("g", {
    className: "cls-3"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M105.53,72.56H73.25a2.48,2.48,0,0,1-2.48-2.48h0a2.48,2.48,0,0,1,2.48-2.48h32.28A2.48,2.48,0,0,1,108,70.08h0A2.48,2.48,0,0,1,105.53,72.56Z"
  })), /*#__PURE__*/React.createElement("g", {
    className: "cls-3"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-5",
    d: "M63.68,42.4H52.82a2.49,2.49,0,0,1-2.48-2.49h0a2.48,2.48,0,0,1,2.48-2.48H63.68a2.48,2.48,0,0,1,2.48,2.48h0A2.49,2.49,0,0,1,63.68,42.4Z"
  })), /*#__PURE__*/React.createElement("g", {
    className: "cls-3"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-5",
    d: "M63.68,117.81H52.82a2.48,2.48,0,0,1-2.48-2.48h0a2.48,2.48,0,0,1,2.48-2.48H63.68a2.48,2.48,0,0,1,2.48,2.48h0A2.48,2.48,0,0,1,63.68,117.81Z"
  })), /*#__PURE__*/React.createElement("g", {
    className: "cls-3"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-5",
    d: "M63.68,132.89H52.82a2.48,2.48,0,0,1-2.48-2.48h0a2.48,2.48,0,0,1,2.48-2.48H63.68a2.48,2.48,0,0,1,2.48,2.48h0A2.48,2.48,0,0,1,63.68,132.89Z"
  })), /*#__PURE__*/React.createElement("g", {
    className: "cls-3"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M96.52,42.4H73.25a2.49,2.49,0,0,1-2.48-2.49h0a2.48,2.48,0,0,1,2.48-2.48H96.52A2.48,2.48,0,0,1,99,39.91h0A2.49,2.49,0,0,1,96.52,42.4Z"
  })), /*#__PURE__*/React.createElement("g", {
    className: "cls-3"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M96.52,102.73H73.25a2.48,2.48,0,0,1-2.48-2.48h0a2.48,2.48,0,0,1,2.48-2.49H96.52A2.48,2.48,0,0,1,99,100.25h0A2.48,2.48,0,0,1,96.52,102.73Z"
  })), /*#__PURE__*/React.createElement("g", {
    className: "cls-3"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M96.52,117.81H73.25a2.48,2.48,0,0,1-2.48-2.48h0a2.48,2.48,0,0,1,2.48-2.48H96.52A2.48,2.48,0,0,1,99,115.33h0A2.48,2.48,0,0,1,96.52,117.81Z"
  })), /*#__PURE__*/React.createElement("g", {
    className: "cls-3"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-5",
    d: "M63.68,27.31H43.82a2.48,2.48,0,0,1-2.48-2.48h0a2.48,2.48,0,0,1,2.48-2.48H63.68a2.48,2.48,0,0,1,2.48,2.48h0A2.48,2.48,0,0,1,63.68,27.31Z"
  })), /*#__PURE__*/React.createElement("g", {
    className: "cls-3"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-5",
    d: "M63.68,72.56H43.82a2.48,2.48,0,0,1-2.48-2.48h0a2.48,2.48,0,0,1,2.48-2.48H63.68a2.48,2.48,0,0,1,2.48,2.48h0A2.48,2.48,0,0,1,63.68,72.56Z"
  })), /*#__PURE__*/React.createElement("g", {
    className: "cls-3"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-5",
    d: "M63.68,102.73H43.82a2.48,2.48,0,0,1-2.48-2.48h0a2.48,2.48,0,0,1,2.48-2.49H63.68a2.48,2.48,0,0,1,2.48,2.49h0A2.48,2.48,0,0,1,63.68,102.73Z"
  })), /*#__PURE__*/React.createElement("g", {
    className: "cls-3"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-5",
    d: "M63.68,57.48H58.23A2.48,2.48,0,0,1,55.74,55h0a2.48,2.48,0,0,1,2.49-2.49h5.45A2.48,2.48,0,0,1,66.16,55h0A2.48,2.48,0,0,1,63.68,57.48Z"
  })), /*#__PURE__*/React.createElement("g", {
    className: "cls-3"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-5",
    d: "M63.68,87.64H58.23a2.48,2.48,0,0,1-2.49-2.48h0a2.48,2.48,0,0,1,2.49-2.48h5.45a2.48,2.48,0,0,1,2.48,2.48h0A2.48,2.48,0,0,1,63.68,87.64Z"
  })), /*#__PURE__*/React.createElement("g", {
    className: "cls-3"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M109.13,27.31H73.25a2.48,2.48,0,0,1-2.48-2.48h0a2.48,2.48,0,0,1,2.48-2.48h35.88a2.48,2.48,0,0,1,2.48,2.48h0A2.48,2.48,0,0,1,109.13,27.31Z"
  }))))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgKaListe);
export default __webpack_public_path__ + "static/media/ka_liste.3a3aebce56bc3dd44187a6bf0d21c659.svg";
export { ForwardRef as ReactComponent };